export default {
    appeventConstants: {
        aboutTheIVAEventName: "abouttheiva",
        changeLanguageEventName: "LanguageChange",
        deferredAppCallEventName: "_sysResume",
        dnnPromptEventName: "DNNPrompt",
        welcomeUserEventName: "WelcomeUser",
        activeSessionPointOfNeedEventName: "ActiveSessionPointOfNeed",
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/appevent-constants.ts